import React, { useState } from "react";
import {
  Box,
  Heading,
  Button,
  useDisclosure,
  useToast,
  HStack,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import RelatedTabModal from "./RelatedComponents/RelatedTabModal";
import RelatedAddDesign from "./RelatedComponents/RelatedAddDesign";
import RelatedDesignTable from "./RelatedComponents/RelatedDesignTable";
const RelatedTab = () => {
  const { id } = useParams(); // <-- parent inventory ID from URL
  const parentInventoryId = id;
  
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isDrawerOpen,
    onOpen: onDrawerOpen,
    onClose: onDrawerClose,
  } = useDisclosure();

  const toast = useToast();

  const handleModalClose = () => {
    onClose();
    // Trigger refresh of the table after modal closes
    setRefreshTrigger(prev => prev + 1);
  };

  const handleDrawerClose = () => {
    onDrawerClose();
    // Trigger refresh of the table after drawer closes
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <Box
      p={6}
      borderRadius="lg"
      bg="white"
      border="1px solid"
      borderColor="gray.200"
      shadow="sm"
    >
      <Heading fontSize="xl" mb={5} color="blue.600">
        Related Designs
      </Heading>

      <HStack spacing={4} mb={6}>
        <Button
          onClick={onOpen}
          colorScheme="blue"
          borderRadius="md"
        >
          + Add Related Designs
        </Button>
        <Button
          onClick={onDrawerOpen}
          colorScheme="blue"
          variant="outline"
          borderRadius="md"
        >
          + Create Related Design
        </Button>
      </HStack>

      {/* Related Design Table */}
      <RelatedDesignTable 
        parentInventoryId={parentInventoryId} 
        refreshTrigger={refreshTrigger}
      />

      {/* Modal for selecting related designs */}
      <RelatedTabModal
        isOpen={isOpen}
        onClose={handleModalClose}
        parentInventoryId={parentInventoryId}
      />

      {/* Drawer for creating new design */}
      <RelatedAddDesign
        isOpen={isDrawerOpen}
        onClose={handleDrawerClose}
        parentInventoryId={parentInventoryId}
      />
    </Box>
  );
};

export default RelatedTab;